import type { ApiS3FileId } from '#/api/types/ApiTypedId';
import type { BackgroundTask } from '#/utils/asyncBackendTask/asyncBackendTaskTypes';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  task: BackgroundTask<void>;
};

function mapResponse(response: ApiResponse) {
  return response.task;
}

const endpoint = new FetchEndpoint({
  urlFactory: (fileId: ApiS3FileId) => `/data/s3-uploads/${fileId}/done`,
  mapResponse,
  optionsFactory: () => ({ method: 'post', body: {} }),
});

export const apiClientFetchS3UploadTask = endpoint.createClientFetchFn();
